import React, { FunctionComponent } from 'react';

import { Header, Footer, CookieConsent } from '..';

import './layout.less';

interface LayoutProps {
  transparentTop?: boolean;
}

export const Layout: FunctionComponent<LayoutProps> = ({ children, transparentTop }) => (
  <>
    <Header transparentTop={transparentTop} />
    <main style={{ minHeight: 'calc(100vh - 198px)' }}>{children}</main>
    <Footer />
    <CookieConsent />
  </>
);
